export default "__VITE_ASSET__DEvAP7F0__"